/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_External_Bookings_Trial_Activity_HeaderInputs */

const en_admin_dashboard_external_bookings_trial_activity_header = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Increase your revenue`)
};

const de_admin_dashboard_external_bookings_trial_activity_header = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umsatz steigern`)
};

const es_admin_dashboard_external_bookings_trial_activity_header = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumenta tus ingresos`)
};

const fr_admin_dashboard_external_bookings_trial_activity_header = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Augmentez vos revenus`)
};

const nl_admin_dashboard_external_bookings_trial_activity_header = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verhoog je omzet`)
};

const it_admin_dashboard_external_bookings_trial_activity_header = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumenta le tue entrate`)
};

const pt_br2_admin_dashboard_external_bookings_trial_activity_header = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumente sua receita`)
};

const pl_admin_dashboard_external_bookings_trial_activity_header = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwiększ swoje przychody`)
};

const hu_admin_dashboard_external_bookings_trial_activity_header = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Növelje bevételét`)
};

const ro_admin_dashboard_external_bookings_trial_activity_header = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cresteti veniturile`)
};

/**
* | output |
* | --- |
* | "Increase your revenue" |
*
* @param {Admin_Dashboard_External_Bookings_Trial_Activity_HeaderInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_external_bookings_trial_activity_header = /** @type {((inputs?: Admin_Dashboard_External_Bookings_Trial_Activity_HeaderInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_External_Bookings_Trial_Activity_HeaderInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_external_bookings_trial_activity_header(inputs)
	if (locale === "de") return de_admin_dashboard_external_bookings_trial_activity_header(inputs)
	if (locale === "es") return es_admin_dashboard_external_bookings_trial_activity_header(inputs)
	if (locale === "fr") return fr_admin_dashboard_external_bookings_trial_activity_header(inputs)
	if (locale === "nl") return nl_admin_dashboard_external_bookings_trial_activity_header(inputs)
	if (locale === "it") return it_admin_dashboard_external_bookings_trial_activity_header(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_external_bookings_trial_activity_header(inputs)
	if (locale === "pl") return pl_admin_dashboard_external_bookings_trial_activity_header(inputs)
	if (locale === "hu") return hu_admin_dashboard_external_bookings_trial_activity_header(inputs)
	return ro_admin_dashboard_external_bookings_trial_activity_header(inputs)
});
export { admin_dashboard_external_bookings_trial_activity_header as "admin.dashboard.external_bookings_trial_activity_header" }